import { getChatToken, clearChatToken } from '../../helper/chat';
import { baseURL } from '../../utils/axios-new';

export const clearChatSession = () => {
  clearChatToken();
};

export const refreshChatSessionTokens = async () => {
  const refreshToken = localStorage.getItem('refreshToken');
  if (!refreshToken) {
    throw new Error('Missing refresh token');
  }

  const response = await fetch(
    `${baseURL}/auth/refresh?key=${process.env.REACT_APP_TOKEN_API_KEY}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ refreshToken })
    }
  );

  if (!response.ok) {
    throw new Error('Failed to refresh chat session');
  }

  const data = await response.json();
  if (data?.idToken) localStorage.setItem('idToken', data.idToken);
  if (data?.refreshToken) localStorage.setItem('refreshToken', data.refreshToken);
  if (data.chatToken) {
    localStorage.setItem('chatToken', data.chatToken);
  }
  return getChatToken();
};
